import { lazy } from "react";
import { defineWebModule } from "../../web/module";
import { measure, weigh } from "./web/AnimalSection";
import "./web/performance.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const GroupWeights = lazy(() => import("./web/GroupSection").then((m) => ({ default: m.GroupWeights })));
const PerformanceSection = lazy(() => import("./web/AnimalSection").then((m) => ({ default: m.PerformanceSection })));
const GainTestJob = lazy(() => import("./web/GainTest").then((m) => ({ default: m.GainTestJob })));
const MeasureForm = lazy(() => import("./web/forms").then((m) => ({ default: m.MeasureForm })));
const PerformanceSettingsPanel = lazy(() => import("./web/Settings").then((m) => ({ default: m.PerformanceSettingsPanel })));
const PerformanceWorkspace = lazy(() => import("./web/Workspace").then((m) => ({ default: m.PerformanceWorkspace })));
const WeighRoundJob = lazy(() => import("./web/WeighRound").then((m) => ({ default: m.WeighRoundJob })));
const WeightForm = lazy(() => import("./web/forms").then((m) => ({ default: m.WeightForm })));

export default defineWebModule({
  id: "performance",
  animalSections: [{
    id: "performance",
    label: "Performance",
    order: 40,
    // Shown when the animal has weights or scores, and for cows so their calves' performance is one tap away.
    show: (a) => !!a.facets.performance || (a.sex === "female" && a.offspring.length > 0),
    Component: PerformanceSection,
  }],
  animalActions: [
    { id: "weigh", label: "Weigh", icon: "scale", eventType: "performance.weight", priority: 45, when: (a) => a.status === "active" || a.status === "missing", run: (a) => weigh(a) },
    { id: "measure", label: "Score or measure", icon: "ruler", eventType: "performance.measurement", priority: 20, when: (a) => a.status === "active" || a.status === "missing", run: (a) => measure(a) },
  ],
  events: {
    "performance.weight": { Form: WeightForm },
    "performance.measurement": { Form: MeasureForm },
  },
  workspaces: { performance: PerformanceWorkspace },
  jobs: { "performance.weigh_round": WeighRoundJob, "performance.gain_test": GainTestJob },
  groupSections: [{ id: "performance", label: "Weights", order: 40, Component: GroupWeights }],
  Settings: PerformanceSettingsPanel,
});
